import { Card } from "antd";
import React, { useState } from "react";
import Utils from "../utils/Utils";

function TranscriptCardSection({interviewData}) {
    
  return (
    <div className="transcript-cards-container flex flex-col md:flex-row gap-x-4 gap-y-3 w-[96%] lg:w-[90%] xl:w-[80%] mx-auto mt-4">
      <Card className="md:w-[50%] w-full bg-[#F2F8FE] text-[1rem] md:text-[1.05rem] leading-5 rounded-[10px] shadow-lg border border-[#D4E7FD] px-0 sm:px-2">
        <div className="flex gap-[.42rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Interview ID</p>
          <p className="w-[61%] text-[#101828] break-words">
            {interviewData?.interviewId || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.65rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Job title</p>
          <p className="w-[61%] text-[#101828] break-words">
            {interviewData?.jobTitle || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.65rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Company name</p>
          <p className="w-[61%] text-[#101828] break-words">
            {interviewData?.companyName || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.65rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Duration</p>
          <p className="w-[61%] text-[#101828]">
            {Utils.convertSecondsToTime(interviewData?.interviewDuration) || "N/A"}
          </p>
        </div>
      </Card>
      <Card className="md:w-[50%] w-full bg-[#F2F8FE] text-[1rem] md:text-[1.05rem] leading-5 rounded-[10px] shadow-lg border border-[#D4E7FD] px-0 sm:px-2">
        <div className="flex gap-[.42rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Candidate name</p>
          <p className="w-[61%] text-[#101828] break-words">
            {interviewData?.candidateName || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.65rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Email ID</p>
          <p className="w-[61%] text-[#101828] break-words	">
            {interviewData?.emailId || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.65rem] font-semibold">
          <p className="w-[37%] text-[#475467]">Timestamp</p>
          <p className="w-[61%] text-[#101828]">
            {Utils.converToDateMonthYear(
              interviewData?.interviewCompletionDate
            ) || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.42rem] mt-[.65rem] font-semibold">
          <p className="w-[37%] text-[#475467]">IP log</p>
          <p className="w-[61%] text-[#101828]">
            {interviewData?.ipLog || "N/A"}
          </p>
        </div>
      </Card>
    </div>
  );
}

export default TranscriptCardSection;
